import {Skeleton} from 'antd'
import React, {useContext} from 'react'
import ContentAlert from 'views/AppLocals/ContentAlert'
import {LoadingWrapper, renderOwnChild} from 'views/Shared'
import UserContext from '../UserContext'
import UserNav from './UserNav'
import {RequiredSystemAdmin} from '../../../../components/RequiredAdmin'
import {ActionPanel} from '../../AdminPanel'
import {TbHeartCheck, TbHeartX} from 'react-icons/tb'

const UserAdminPanel = ({item, open = true}) => {
    if (!!!open) return null
    return (
        <ActionPanel
            item={item}
            title="administration panel"
            actions={[
                {
                    key: 'ADD_TO_RECOMMENDATION',
                    label: 'add to recommendation',
                    icon: <TbHeartCheck size={15} className="text-color-400"/>,
                },
                {
                    key: 'REMOVE_FROM_RECOMMENDATION',
                    label: 'remove from recommendation',
                    icon: <TbHeartX size={15} className="text-color-400"/>,
                },
            ]}
        />
    )
}

const NavSkeleton = () => (
    <div className="flex flex-col gap-4">
        <div className="flex items-center gap-2 px-2 py-2 border-b border-color-50">
            {[72, 96, 120].map((w, i) => (
                <div
                    key={i}
                    className="h-7 rounded-md background-200"
                    style={{width: w}}
                />
            ))}
        </div>
        <div className="px-2 flex flex-col gap-4">
            <Skeleton
                active
                avatar
                paragraph={{rows: 2}}
            />
            <Skeleton
                active
                avatar
                paragraph={{rows: 2}}
            />
            <Skeleton
                active
                avatar
                paragraph={{rows: 1}}
            />
        </div>
    </div>
)

const UserContent = ({Wrapper = renderOwnChild}) => {
    const {user} = useContext(UserContext)
    return (
        <Wrapper>
            <LoadingWrapper
                center={false}
                isLoading={!user}>
                <ContentAlert entity={user}/>
            </LoadingWrapper>
            <div className="space-y-3">
                <RequiredSystemAdmin>
                    <UserAdminPanel item={user}/>
                </RequiredSystemAdmin>
                {!user ? <NavSkeleton/> : <UserNav/>}
            </div>
        </Wrapper>
    )
}

export default UserContent
